import './BudgetsList.scss'

import { useEffect, useState } from "react"
import { destroyBudget, insertBudget, listBudgets, updateBudget } from "../../ApiInterface"
import BudgetPieChart from "./BudgetPieChart"
import { regularBudgets } from "../../Helpers"


const BudgetsList = () => {
    const [budgets, setBudgets] = useState([] as Budget[])
    const fetchBudgets = () => {
        listBudgets().then((budgets) => setBudgets(regularBudgets(budgets)))
    }
    useEffect(fetchBudgets, [])

    const newBudget = () => insertBudget({name: "Autre", amount_cents: 10000}).then(fetchBudgets)
    const deleteBudget = (budget: Budget) => destroyBudget(budget.id).then(fetchBudgets)
    const editBudget = (budget: Budget, params: BudgetParams) => updateBudget(budget.id, params).then(fetchBudgets)

    return <div className='budgets-page'>
        { budgets.length > 0 && <BudgetPieChart
            budgets={budgets}
            newBudget={newBudget}
            onUpdate={(budget, params) => editBudget(budget, params)}
            deleteBudget={deleteBudget}
            />}

    </div>
}

export default BudgetsList